import { MapDialog } from "./MapDialog";
import { html } from "lit-html";
import { data } from "@escapio/shared/state/payload";
import { translate } from "@escapio/shared/l10n/translate";
import { store } from "../hotel/DataStore";
import { track } from "../../tracker/EventTracker";
import { addHash } from "../hotel/add-hash";
import { format } from "../hotel/FilterToHashMapper";
import { trackNoPrices } from "../hotel/tracker";
import { fetchPricesForCurrentTravelData } from "../../api/hotel-prices";
import { onChangeAny } from "../../state/travelData";
import { hasDirectLink } from "@escapio/portal/state/DirectLink";

import "./map-libre/HotelMap";
import { NEARBY_EVENT_ACTION_SUFFIX } from "@escapio/portal/tracker/Clickout";
import { NO_PRICES_STATE } from "@escapio/portal/api/prices-state";

const { hotel } = data;

const prices = new WeakMap();
export class ProfileMapDialog extends MapDialog {
	constructor() {
		super();
		this.hash = "";
		this.titleText = hotel.name;
		this.subtitleText = `${hotel.street}, ${hotel.zip} ${hotel.city_name}, ${hotel.region_name}, ${hotel.country_name}`;
		this.closeButtonText = translate("hotel_close_map");
		this.filters = {};

		onChangeAny(this.resetPrices.bind(this));
		store.subscribe(this.update.bind(this));
		this.update(store.getState());
	}

	getTemplateContent() {
		return html`
			<esc-maplibre-hotel-map
				track-name="Profil Karte"
				track-hotel-secondary-action-suffix=" - ${hotel.id}"
				.visibleHotels=${this.visibleHotels}
				.primaryHotels=${[hotel].map(addHash(this.hash))}
				.secondaryHotels=${data.nearby_hotels.map(addHash(this.hash))}
				.prices=${this.prices}
				@ready=${this.onMapReady}
				@NoPrices=${this.onNoPrices}
			></esc-maplibre-hotel-map>
			${this.getTransparentHeader()}
		`;
	}

	async resetPrices() {
		this.requestPrices();
		this.update(store.getState());
	}

	async requestPrices() {
		const [nearbyHotelsLoading, hotelsPrices] = data.nearby_hotels.reduce(
			(lists, hotel) => {
				if (hotel.exclusive) {
					lists[1][hotel.id] = NO_PRICES_STATE;
				} else {
					lists[0][hotel.id] = hotel;
				}
				return lists;
			},
			[{}, {}],
		);

		prices.set(this, hotelsPrices);

		this.filters = store.getState().filters;
		const fetchedPrices = await fetchPricesForCurrentTravelData(
			Object.keys(nearbyHotelsLoading),
			this.filters,
		);

		Object.entries(fetchedPrices).forEach(([hotelId, prices]) => {
			hotelsPrices[hotelId] = prices;
		});

		prices.set(this, hotelsPrices);

		this.update(store.getState());
	}

	get visibleHotels() {
		return [
			hotel.id,
			...data.nearby_hotels
				.filter(
					hotel =>
						!prices.get(this)?.[hotel.id]?.hasLoadedWithoutOffers ||
						hasDirectLink(hotel),
				)
				.map(({ id }) => Number(id)),
		];
	}

	onMapReady({ target }) {
		target.selectHotel(hotel.id);
	}

	onNoPrices({ detail }) {
		trackNoPrices(`Profil Karte${NEARBY_EVENT_ACTION_SUFFIX}`, detail);
	}

	update(state) {
		if (
			state.filters.cancelation !== this.filters.cancelation ||
			state.filters.board !== this.filters.board
		) {
			return this.resetPrices();
		}

		this.prices = {
			...prices.get(this),
			[hotel.id]: state.prices,
		};
		this.hash = format(state.filters);
		this.render();
	}

	show(trackName) {
		super.show();
		track("Hotel", "Klick Karte öffnen", trackName);
	}
}
